module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-5929b13b.svg";